import script from "./ProfileView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileView.vue?vue&type=script&lang=ts&setup=true"

import "./ProfileView.vue?vue&type=style&index=0&id=674916a6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-674916a6"]])

export default __exports__